import { DropdownMenuItem } from "@/components/atoms/ui/dropdown-menu";

export type DropdownActionItemProps = {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
};

const DropdownActionItem = ({ label, icon, onClick, disabled }: DropdownActionItemProps) => {
  return (
    <DropdownMenuItem className="text-urbix-gray-1000" disabled={disabled} onClick={onClick}>
      {icon && <span className="mr-2 *:h-[1.042rem] *:w-[1.042rem]">{icon}</span>}
      {label}
    </DropdownMenuItem>
  );
};

export default DropdownActionItem;
